import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';

import {scrolledToExperience} from 'shared/portfolio/actions/work-experiences';

import {WorkExperience as WorkExperienceType} from './work-experience-form-wrapper';
import Text from 'shared/components/text';
import {MONTH_ABBRVS} from 'shared/utils';

interface Props {
  workExperience: WorkExperienceType;
  hover?: boolean;
}

const WorkExperience = ({
  workExperience,
  hover,
  workExperience: {startMonth, startYear, endMonth, endYear, currentWorkplace},
}: Props) => {
  const dispatch = useDispatch();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (workExperience.scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToExperience(workExperience._id));
      }, 550);
    }
  }, [dispatch, workExperience._id, workExperience.scrollTo]);

  return (
    <div className="work-experience-card" ref={ref} data-testid="work-experience">
      <div className="portfolio-sections header-container">
        <div className="portfolio-sections card-header">
          <Text header emphasis inline weight={4} hover={hover}>
            {workExperience.place}
          </Text>
        </div>
        {hover || (
          <Text inline weight={5} hover={hover} className="portfolio-sections year-ranges">
            {MONTH_ABBRVS[startMonth]} {startYear} -{' '}
            {currentWorkplace
              ? 'Present'
              : endMonth !== null
              ? `${MONTH_ABBRVS[endMonth]} ${endYear}`
              : ''}
          </Text>
        )}
      </div>
      <Text weight={5} hover={hover} color="darkgrey">
        {workExperience.responsibilities}
      </Text>
      <Text weight={5} hover={hover} color="darkgrey">
        {`${workExperience.hoursPerWeek} ${
          workExperience.hoursPerWeek === 1 ? 'hour / week' : 'hours / week'
        }`}
      </Text>
    </div>
  );
};

export default WorkExperience;
